// Admin Widget 配置檔案
// 定義所有可用的 widgets

import WorkflowWidget from './widgets/WorkflowWidget'

// Widget 類型定義
export const WIDGET_TYPES = {
  WORKFLOW: 'workflow',
}

// 可用的 Widgets 清單（Widget 庫）
// Workflow widgets 會動態從 API 載入
export const STATIC_WIDGETS = []

// 預設 Dashboard 配置
export const DEFAULT_DASHBOARD_CONFIG = []

// 根據 ID 獲取 Widget 配置
export const getWidgetById = (id, availableWidgets) => {
  return availableWidgets.find(widget => widget.id === id)
}

// Workflow Widget 的 component
export { WorkflowWidget }
